import BaseRequest from '../_baseRequest';
import { getLanguage } from 'components/langSelector/LangSelector';
const baseUrl = 'Report';
const baseUrlSecond = 'Report/ReportByUrl';
const language = getLanguage();
const TerritoryService = {
  ambitiGeografici: () => {
    const req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'get',
      '/api/' + baseUrl + '/AmbitiGeografici' + '?plang=' + language,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },
  unitaAmministrative: (data, ambito, pTab, dataA) => {
    const req = new BaseRequest();

    let param = '';
    if (dataA) {
      param = '?dataA=' + dataA;
    }
    return req.makeRequest(
      {},
      {},
      null,
      'get',
      '/api/' + baseUrl + '/UnitaAmministrative/' + data + '/' + ambito + '/' + pTab + param,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },
  ambitoUA: (data, unita, ambito, ptab, dataA) => {
    const req = new BaseRequest();

    let dataInizio = 'pdata=' + data;
    let dataFine = '';
    if (dataA) {
      dataFine = '&pdataa=' + dataA;
      dataInizio = 'pdatada=' + data;
    }

    const url =
      //&plang=EN
      `anagrafica_report_ambito_ua?${dataInizio}&haRuolo&pambito=${ambito}&ptab=${ptab}&punitamm=${unita}${dataFine}&plang=${language}`;

    return req.makeRequest(
      {},
      { url },
      null,
      'post',
      '/api/' + baseUrlSecond,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  header: (data, funzione) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {},
      null,
      'get',
      '/api/' + baseUrl + '/Header/' + data + '/' + funzione,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },

  types: (data, funzione) => {
    let url;
    const req = new BaseRequest();
    if (data[1] === undefined) {
      url = `anagrafica_report_metadato?pfun=${funzione}&haRuolo&pdata=${data[0]}&plang=${language}`;
    } else {
      url = `anagrafica_report_metadato?pfun=${funzione}&haRuolo&pdatada=${data[0]}&pdataa=${data[1]}&plang=${language}`;
    }

    return req.makeRequest(
      {},
      { url },
      null,
      'post',
      '/api/' + baseUrlSecond,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  spool: (data, funzione, params = {}, sortParams) => {
    const req = new BaseRequest();

    return req.makeRequest(
      params,
      sortParams,
      null,
      'post',
      '/api/' + baseUrl + '/Spool/' + data + '/' + funzione,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  }
};

export default TerritoryService;
